module.exports = __webpack_public_path__ + "img/ebersanhueza.617195c1.jpg";